import { HMCATableViewMode } from 'features/RegulatoryTools/HCAMCA/Components/Tables'

interface ITableViewToggle {
  tableMode: HMCATableViewMode
  setTableMode: (value: HMCATableViewMode) => void
}

const TableViewToggle = ({ tableMode, setTableMode }: ITableViewToggle) => {
  const activeClasses = [
    'px-3 py-[9px] rounded-l-sm',
    'bg-lighthouseBlue bg-opacity-30 leading-6',
    'font-medium leading-none'
  ].join(' ')

  const inactiveClasses = [
    'px-3 py-[9px] rounded-r-sm',
    'bg-lighthouseBlue bg-opacity-10 leading-6',
    'font-medium text-gray-500 leading-none'
  ].join(' ')

  return (
    <div className='pr-4'>
      <button
        className={`rounded-l-sm ${
          tableMode === HMCATableViewMode.HMCA ? activeClasses : inactiveClasses
        }`}
        onClick={() => setTableMode(HMCATableViewMode.HMCA)}
      >
        Consequence Area
      </button>
      <button
        className={`rounded-r-sm ${
          tableMode === HMCATableViewMode.HMCA ? inactiveClasses : activeClasses
        }`}
        onClick={() => setTableMode(HMCATableViewMode.ClassLocation)}
      >
        Class Location
      </button>
    </div>
  )
}

export default TableViewToggle
